import "./PdfViewer.css";
import { Document, Page, pdfjs } from "react-pdf"; //https://www.npmjs.com/package/react-pdf
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { useState, useRef, useEffect } from "react";
import MyCanvas from "../MyCanvas/MyCanvas";
import html2canvas from "html2canvas";
import { run } from "../aiUtils";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

function PdfViewer({
  onTranslationUpdate,
  onLoadingChange,
  selected,
  currFile,
  pageNumber,
  setPageNumber,
}) {
  const [numPages, setNumPages] = useState(null);
  const [pageDimensions, setPageDimensions] = useState({ width: 0, height: 0 });
  const pageRef = useRef(null);
  const [screenShot, setScreenShot] = useState(null);
  const [translation, setTranslation] = useState(null);
  const divRef = useRef(null);
  const [canvasCleared, setCanvasCleared] = useState(false);
  const [pageHeight, setPageHeight] = useState(400);

  useEffect(() => {
    const updatePageHeight = () => {
      // Option 1: Using viewport units (vh) - e.g., 80% of viewport height
      const newHeightVh = window.innerHeight * 0.6;
      setPageHeight(newHeightVh);

      // // Option 2: Using a fixed ratio of the container width
      // if (pageRef.current) {
      //   const containerWidth = pageRef.current.offsetWidth;
      //   const newHeightRatio = containerWidth * 0.5; // Example ratio
      //   setPageHeight(newHeightRatio);
      // }
    };

    updatePageHeight(); // Set initial height
    window.addEventListener("resize", updatePageHeight); // Update on resize

    return () => window.removeEventListener("resize", updatePageHeight); // Cleanup
  }, []);

  const handleClearCanvas = () => {
    setCanvasCleared(true);
  };

  const afterClearCanvas = () => {
    setCanvasCleared(false);
  };

  useEffect(() => {
    handleClearCanvas();
  }, [selected]);

  const handleLoadError = (error) => {
    console.error("Error loading PDF:", error);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onPageRenderSuccess = (page) => {
    if (divRef.current) {
      const { width, height } = divRef.current.getBoundingClientRect();
      // console.log("Div width:", width);
      // console.log("Div height:", height);

      // Set the width and height here, within the scope
      setPageDimensions({
        width: width,
        height: height,
      });
    }
  };

  const goToPrevPage = () => {
    setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);
    handleClearCanvas();
  };

  const goToNextPage = () => {
    setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);
    handleClearCanvas();
  };

  const captureScreenshot = () => {
    onLoadingChange(true);
    const pdfAndCanvasDiv = document.querySelector(".pdf-and-canvas"); // Get the target div

    if (pdfAndCanvasDiv) {
      html2canvas(pdfAndCanvasDiv).then(function (canvas) {
        const imgData = canvas.toDataURL("image/png");
        setScreenShot(imgData);

        run(imgData).then((result) => {
          // console.log(onTranslationUpdate);
          // console.log(result);
          setTranslation(result);
          onTranslationUpdate(result);
          onLoadingChange(false);
        });
      });
    } else {
      console.error("Could not find the .pdf-and-canvas div.");
    }
  };

  return (
    <div className="pdf-container">
      <div className="pdf-and-canvas" ref={divRef}>
        <Document
          className="pdf-page"
          file={currFile}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={handleLoadError}
        >
          <Page
            pageNumber={pageNumber}
            height={pageHeight}
            onRenderSuccess={onPageRenderSuccess}
            ref={pageRef}
            scale={1.32}
          />
        </Document>
        <MyCanvas
          width={pageDimensions.width}
          height={pageDimensions.height}
          className="page-canvas"
          captureScreenshot={captureScreenshot}
          clear={canvasCleared}
          onClear={afterClearCanvas}
          isSelected={selected}
        />
      </div>
      <p>
        Page {pageNumber} of {numPages}
      </p>
      <div className="pdf-nav">
        <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
          Previous
        </button>
        <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
          Next
        </button>
      </div>
      {/* <button onClick={captureScreenshot}>Screenshot</button>
      {screenShot ? (
        <img src={screenShot} alt="Captured Screenshot" />
      ) : (
        <h1>No Screenshot yet</h1>
      )}
      {translation ? <h1>{translation}</h1> : <h1>No Translation yet</h1>} */}
    </div>
  );
}

export default PdfViewer;
